// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.config[data-v-6e6654eb] {\n  margin-top: 10px;\n}\n.parameters[data-v-6e6654eb] {\n  margin-top: 10px;\n  margin-left: 20px;\n}\nul[data-v-6e6654eb] {\n  margin-top: 5px;\n}\nli[data-v-6e6654eb] {\n  margin-top: 5px;\n}\n", ""]);
// Exports
module.exports = exports;
